import { ChartBarLineIcon } from '@hugeicons/core-free-icons';
import { createIcon } from '../icon';

export const BarChart3 = /* @__PURE__ */ createIcon(ChartBarLineIcon, 'BarChart3');
